import React from 'react';
import { LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { CHECKOUT_URL, PRICE, PRICE_FULL } from '../data/content';
export function OfferSection() {
  return <section id="oferta" aria-labelledby="oferta-titulo" className="border-b border-line bg-canvas" data-id="element-112" data-mp="8lc2eic6zk9r">
      <div className="mx-auto max-w-2xl px-4 py-9 text-center sm:px-6" data-id="element-113" data-mp="idi2yggifa0k">
        <p className="font-display text-[0.65rem] font-bold uppercase tracking-[0.16em] text-danger" data-id="element-114" data-mp="ifazv41bmfvd">
          Oferta especial — Mega Pack completo 6 en 1
        </p>
        <h2 id="oferta-titulo" className="mt-2 font-display text-lg font-extrabold leading-tight text-ink sm:text-2xl" data-id="element-115" data-mp="rf7tzl6hc6xt">
          Accedé al sistema ahora y empezá hoy
        </h2>

        <Reveal className="mt-4 rounded-2xl border-2 border-accent bg-surface p-5" data-id="element-116" data-mp="2t6ued3vv93lb">
          <p className="font-display text-sm font-extrabold uppercase text-accent sm:text-base" data-id="element-117" data-mp="2y55mna6ij61f">
            Mega Pack Electrónica para Emprender
          </p>
          <p className="mt-2 text-xs text-ink-muted" data-id="element-118" data-mp="xx1x1tgb6c3f">
            Precio normal:{' '}
            <span className="line-through" data-id="element-119" data-mp="sxp18j7gluop">{PRICE_FULL} ARS</span>
          </p>

          <p className="mt-3 inline-block rounded-md bg-danger-soft px-3 py-1 font-display text-[0.65rem] font-bold uppercase tracking-wide text-danger" data-id="element-120" data-mp="svmd64pvabmm">
            Oferta de lanzamiento
          </p>

          <p className="mt-2 font-display text-3xl font-black text-ink sm:text-4xl" data-id="element-121" data-mp="1lka0s6y39d3c">
            {PRICE}
            <span className="ml-1.5 text-base font-bold text-ink-muted" data-id="element-122" data-mp="1glgq0ma6s06v">
              ARS
            </span>
          </p>
          <p className="mt-0.5 font-display text-[0.65rem] font-bold uppercase tracking-[0.16em] text-ink-subtle" data-id="element-123" data-mp="17mv6ooww4h51">
            Pago único
          </p>

          <p className="mt-3 text-xs text-ink-muted" data-id="element-124" data-mp="17uaqj7v7yyg">
            Aprovechá el precio promocional mientras esté disponible.
          </p>

          <CtaButton href={CHECKOUT_URL} external size="lg" className="mt-4" data-id="element-125" data-mp="3tu98d4tab7gp">
            Sí, quiero el Mega Pack por {PRICE}
          </CtaButton>

          <div className="mt-3 flex flex-wrap items-center justify-center gap-x-3 gap-y-1.5 text-[0.7rem] text-ink-muted" data-id="element-126" data-mp="2n6h6ddg516h">
            <span className="flex items-center gap-1.5" data-id="element-127" data-mp="3kve0zpei7rbt">
              <ZapIcon size={12} className="text-accent" data-id="element-128" data-mp="3otvcel4yjnz1" />
              Acceso inmediato
            </span>
            <span className="text-ink-subtle" data-id="element-129" data-mp="3b2q6x2ews1gs">•</span>
            <span className="flex items-center gap-1.5" data-id="element-130" data-mp="3ftyfjw8ezisw">
              <LockIcon size={12} className="text-ink-subtle" data-id="element-131" data-mp="3fvt4rmqpxx2s" />
              Pago seguro
            </span>
            <span className="text-ink-subtle" data-id="element-132" data-mp="317579axbbda7">•</span>
            <span className="flex items-center gap-1.5" data-id="element-133" data-mp="363ncsd0gvfnl">
              <ShieldCheckIcon size={12} className="text-success" data-id="element-134" data-mp="3622fwgqojkmk" />
              Garantía 7 días
            </span>
          </div>
        </Reveal>
      </div>
    </section>;
}